import IconFilter from "@mui/icons-material/FilterAlt";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import { MapPillPanel } from "~/modules/map/components/MapPillPanel";
import CheckboxInput from "~/shared/components/CheckboxInput";

import { usePlannerV2VisitFilters } from "../../hooks/usePlannerV2VisitFilters";

export function PlannerV2RouteFilters() {
    const { t } = useTranslation("plannerV2");
    const { filterValues, setFilterValues, hasAnyFilters } = usePlannerV2VisitFilters();

    return (
        <MapPillPanel icon={<IconFilter />} title={t("visitFilters.title")} hasDot={hasAnyFilters}>
            <Box padding={2}>
                <CheckboxInput
                    label={t("visitFilters.includeUnavailableFilter")}
                    value={filterValues.filterFieldworkerIncludeUnavailable}
                    onChange={value => setFilterValues({ filterFieldworkerIncludeUnavailable: value })}
                />
            </Box>
        </MapPillPanel>
    );
}
